import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.deal)?_c(VListItem,[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.child ? _vm.$t('childDeal') : _vm.$t('parentDeal')))]),_c(VListItemTitle,[_vm._v(_vm._s(_vm.deal.refnum))])],1),_c(VListItemAction,[_c(VBtn,{attrs:{"icon":"","small":"","to":_vm.goToDeal()}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(_vm._s(_vm.$vuetify.icons.values.view))])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }